import { SportsStatIdConfig } from '@collector/desktop-feature-statistics'
import { SoccerStatId } from '@collector/sportsapi-client-legacy'

export const teamStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: SoccerStatId.TotalShots },
  { sportStatId: SoccerStatId.ShotsOnTarget },
  { sportStatId: SoccerStatId.ShotsOffTarget },
  { sportStatId: SoccerStatId.ShotsBlocked },
  { sportStatId: SoccerStatId.Fouls },
  { sportStatId: SoccerStatId.Offsides },
  { sportStatId: SoccerStatId.FreeKicks },
  { sportStatId: SoccerStatId.ThrowIns },
  { sportStatId: SoccerStatId.Assists },
  {
    sportStatId: SoccerStatId.BallPossessionPercentage,
    format: { percent: true },
  },
  { sportStatId: SoccerStatId.ExpectedGoals },
  { sportStatId: SoccerStatId.Passes },
]

// TODO: allow to declare just SoccerStatId[] if other properties are not needed (format, edit)

export const teamStatsAccordionIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: SoccerStatId.Goals },
  { sportStatId: SoccerStatId.OwnGoals },
  { sportStatId: SoccerStatId.PenaltiesGiven },
  { sportStatId: SoccerStatId.PenaltiesScored },
  { sportStatId: SoccerStatId.PenaltiesSaved },
  { sportStatId: SoccerStatId.PenaltiesMissed },
  { sportStatId: SoccerStatId.Attacks },
  { sportStatId: SoccerStatId.DangerousAttacks },
  { sportStatId: SoccerStatId.DangerousFreeKicks },
  { sportStatId: SoccerStatId.GoalKicks },
  { sportStatId: SoccerStatId.ShotWoodwork },
  { sportStatId: SoccerStatId.GoalLineClearences },
  { sportStatId: SoccerStatId.Tackles },
  { sportStatId: SoccerStatId.Interceptions },
]

export const playerStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: SoccerStatId.Goals },
  { sportStatId: SoccerStatId.Assists },
  { sportStatId: SoccerStatId.OwnGoals },
  { sportStatId: SoccerStatId.YellowCards },
  { sportStatId: SoccerStatId.RedCards },
  { sportStatId: SoccerStatId.PenaltiesGiven },
  { sportStatId: SoccerStatId.PenaltiesScored },
  { sportStatId: SoccerStatId.PenaltiesSaved },
  { sportStatId: SoccerStatId.PenaltiesMissed },
  { sportStatId: SoccerStatId.FirstLineups },
  { sportStatId: SoccerStatId.Bench },
  { sportStatId: SoccerStatId.Appearance },
  { sportStatId: SoccerStatId.CurrentGoalkeeper },
  { sportStatId: SoccerStatId.TotalShots },
  { sportStatId: SoccerStatId.ShotsOnTarget },
  { sportStatId: SoccerStatId.ShotsOffTarget },
  { sportStatId: SoccerStatId.ShotsBlocked },
  { sportStatId: SoccerStatId.GoalkeeperSaves },
  { sportStatId: SoccerStatId.Fouls },
  { sportStatId: SoccerStatId.Offsides },
  { sportStatId: SoccerStatId.Blocks },
  { sportStatId: SoccerStatId.GoalLineClearences },
  { sportStatId: SoccerStatId.ShotWoodwork },
  { sportStatId: SoccerStatId.Tackles },
  { sportStatId: SoccerStatId.Interceptions },
]
